import { FileType } from '@/common/constants';

export const getFileType = (url: string): FileType | undefined => {
  const formatStr = url?.split('?')?.[0]?.split('.')?.pop();
  const type = formatStr ? formatStr.trim().toUpperCase() : null;

  return FileType[type as keyof typeof FileType];
};
